export default "__VITE_ASSET__CYhcTi7i__"